import React from 'react';
import { Route, Switch } from 'react-router-dom';

import UnApprovedTransactionsTable from '../../components/UnApprovedTransactionTable';
import UnApprovedTransactionView from '../../components/UnApprovedTransactionView';

const UnApprovedTransactions = ({ match }) => {
  return (
    <div className="w-100 h-100">
      <Switch>
        <Route
          path={match.url}
          exact
          render={(props) => {
            return <UnApprovedTransactionsTable {...props} />;
          }}
        />
        <Route
          path={`${match.url}/:txId`}
          exact
          render={(props) => {
            return <UnApprovedTransactionView {...props} />;
          }}
        />
      </Switch>
    </div>
  );
};

export default UnApprovedTransactions;
